<template>
	<PageHeaderLayout class="goals-page-header">
		<template #title>
			{{ $t( "common-gokr.components.MyGoalsPageHeader.title" ) }}
		</template>
		<template #right>
			<TeamingButton
				:disabled="disabled"
				size="SMALL"
				@click="$emit( `newGoal` )"
			>
				<span>
					&plus;&nbsp;
					<span class="new-goal-text">
						{{ $t( "common-gokr.components.MyGoalsPageHeader.newGoalButton" ) }}
					</span>
				</span>
			</TeamingButton>
		</template>
	</PageHeaderLayout>
</template>

<script>
import { PageHeaderLayout, TeamingButton } from "@teaming/common-ui";
export default {
	name: "MyGoalsPageHeader",
	emits: [ "newGoal", ],
	components: {
		TeamingButton,
		PageHeaderLayout,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.new-goal-text {
	display: none;
	@include for-size('md') {
		display: inline;
	}
}
</style>
